import { motion } from "framer-motion";
import { useT } from "@/i18n/LanguageContext";

const ROMAN = ["I", "II", "III"];

export default function Words() {
  const { t } = useT();
  const WORDS = ROMAN.map((n) => ({ n, body: t(`words.${n}`) }));

  return (
    <section
      id="words"
      data-testid="words-section"
      className="relative w-full bg-bone text-ink py-[20vh] px-6 md:px-10"
    >
      <div className="flex items-end justify-between border-b border-ink/30 pb-6">
        <p className="font-mono text-[10px] tracking-[0.3em] uppercase">{t("words.eyebrow")}</p>
        <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-ink/60">I · II · III</p>
      </div>

      <motion.h2
        initial={{ y: 60, opacity: 0 }}
        whileInView={{ y: 0, opacity: 1 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
        className="mt-12 font-serif font-black uppercase text-5xl md:text-7xl lg:text-8xl leading-[0.85] tracking-tighter max-w-5xl"
      >
        {t("words.headline_pre")}{" "}
        <em className="font-serif italic font-normal">{t("words.headline_emph")}</em>{" "}
        {t("words.headline_post")}
      </motion.h2>

      <div className="mt-20 grid grid-cols-1 lg:grid-cols-3 gap-12 lg:gap-16 items-stretch">
        {WORDS.map((w, i) => (
          <motion.article
            key={w.n}
            initial={{ opacity: 0, y: 60 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.9, delay: i * 0.1, ease: [0.16, 1, 0.3, 1] }}
            data-testid={`word-${w.n}`}
            className="relative border-t border-ink pt-8 flex flex-col h-full"
          >
            <div className="flex items-baseline justify-between mb-6">
              <span className="font-serif italic text-6xl md:text-7xl leading-none text-crimson">{w.n}.</span>
              <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-ink/50">
                {String(i + 1).padStart(2, "0")} / 03
              </span>
            </div>
            <p className="font-sans text-base md:text-lg leading-[1.6] text-ink/85">
              {w.body}
            </p>
            <div className="mt-auto pt-8 flex items-center gap-3">
              <span className="block h-px w-10 bg-crimson" />
              <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-ink/50">
                {t("words.fragment_label")} {w.n}
              </span>
            </div>
          </motion.article>
        ))}
      </div>
    </section>
  );
}
